import * as React from "react";

import {
  ReactCheckout2022Route,
  useDeliveryDetailsPaymentPageKickoff,
  useDeliveryDetailsUserExperience_asController,
  useReactCheckout2022Router,
  useReactCheckout2022Router_asController,
} from "../providers";

const WhenToShowTheJourney: string[] = [
  ReactCheckout2022Route.delivery_details,
  ReactCheckout2022Route.payment,
];
export const HeaderJourney: React.FunctionComponent = () => {
  const { currentRoute } = useReactCheckout2022Router();
  const { navigateTo } = useReactCheckout2022Router_asController();
  const { hasBeenToThePaymentPage } = useDeliveryDetailsPaymentPageKickoff();

  const { handleReviewAndPay } =
    useDeliveryDetailsUserExperience_asController();

  const isCurrentlyOnThePaymentPage = React.useMemo(() => {
    return currentRoute === ReactCheckout2022Route.payment;
  }, [currentRoute]);
  const isCurrentlyOnTheDeliveryDetailsPage = React.useMemo(() => {
    return currentRoute === ReactCheckout2022Route.delivery_details;
  }, [currentRoute]);
  const canNavigateToPaymentFromDeliveryDetails = React.useMemo(
    () => hasBeenToThePaymentPage,
    [hasBeenToThePaymentPage]
  );
  if (!WhenToShowTheJourney.includes(currentRoute)) {
    return null;
  }
  return (
    <ul className="journey">
      {[
        {
          value: ReactCheckout2022Route.delivery_details,
          displayText: "Delivery Details",
        },
        {
          value: ReactCheckout2022Route.payment,
          displayText: "Review & Pay",
        },
      ].map((thisStep, thisStepIndex) => {
        const isThisStepTheCurrentStep = thisStep.value === currentRoute;
        const handleClick: React.MouseEventHandler<HTMLLIElement> = (event) => {
          event.preventDefault();
          if (
            isCurrentlyOnThePaymentPage &&
            thisStep.value === ReactCheckout2022Route.delivery_details
          ) {
            navigateTo(ReactCheckout2022Route.delivery_details);
          }
          if (
            hasBeenToThePaymentPage &&
            isCurrentlyOnTheDeliveryDetailsPage &&
            thisStep.value === ReactCheckout2022Route.payment
          ) {
            handleReviewAndPay();
          }
        };
        return (
          <li
            key={thisStep.value}
            className={`${
              isThisStepTheCurrentStep
                ? "yes-this-currently-where-i-am"
                : "not-currently-where-im-at"
            } ${
              isCurrentlyOnThePaymentPage ||
              canNavigateToPaymentFromDeliveryDetails
                ? "available-to-navigate-to"
                : "not-available-to-navigate-to"
            }`}
            onClick={handleClick}
          >
            {thisStepIndex > 0 && <div className="line"></div>}
            <div className="digit">{`${thisStepIndex + 1}`}</div>
            <div className="displayText">{`${thisStep.displayText}`}</div>
          </li>
        );
      })}
    </ul>
  );
};
